export const sidePanelTools = [
	'annotations',
	'densityMap',
	'digitalTwins',
	'lasso',
	'resectionPlanes',
	'surgicalPlan',
	'visibility',
] as const;

export type SidePanelTool = (typeof sidePanelTools)[number];
